import { useState } from "react";
import {
  useGetWelfareContentStatusQuery,
  useUpdateWelfareContentAsAdminMutation,
} from "../../../lib/apollo/graphql/generated";
import ActiveStatusSelectBox from "../../common/components/ActiveStatusSelectBox";
import Modal, { ModalProps } from "../../common/components/Modal";
import Loader from "../../common/components/Loader";
import BasicButton from "../../common/components/BasicButton";

interface UpdateWelfareModalProps extends ModalProps {
  welfareId: string;
}

export default function UpdateWelfareModal({
  welfareId,
  open,
  onClose,
}: UpdateWelfareModalProps) {
  const [statusId, setStatusId] = useState("");

  const { loading } = useGetWelfareContentStatusQuery({
    variables: {
      welfareContentId: welfareId,
    },
    onCompleted: (res) => {
      const statusId = res?.getWelfareContentAsAdmin.statusId;
      setStatusId(statusId);
    },
    skip: !welfareId,
  });

  const [updateWelfare, { loading: isUpdating }] =
    useUpdateWelfareContentAsAdminMutation({
      onCompleted: () => {
        alert("복지정보를 수정했습니다.");
        onClose();
      },
      refetchQueries: ["GetWelfareContentsAsAdmin", "GetWelfareContentStatus"],
    });

  if (loading) {
    return (
      <Modal
        title="복지정보 상태 수정"
        width="500px"
        open={open}
        onClose={onClose}
      >
        <Loader />
      </Modal>
    );
  }

  return (
    <Modal
      title="복지정보 상태 수정"
      open={open}
      onClose={onClose}
      width="500px"
    >
      <div className="mt-10 w-full">
        <ActiveStatusSelectBox value={statusId} onSelect={setStatusId} />
      </div>
      <BasicButton
        text="상태 수정"
        className="mt-auto w-1/2 self-center"
        disabled={!statusId || !welfareId}
        loading={isUpdating}
        onClick={() => {
          if (!statusId || isUpdating) {
            return;
          }

          updateWelfare({
            variables: {
              statusId,
              welfareContentId: welfareId,
            },
          });
        }}
      />
    </Modal>
  );
}
